<template>
  <div class="transportDeliveryOrder">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <el-dialog title="选择入账日期" center :visible.sync="dialogVisible" width="20%">
      <el-date-picker
        v-model="postDate"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        placeholder="选择日期"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectDate">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增的时候选择筛选供应商发货指令商品明细dialog -->
    <creatDialog ref="creatDialog" />
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
    <!-- <sirui-upload :action="action" @getData="getData" ref="SiruiUpload" :data="{...tokenInfo}"></sirui-upload> -->
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import creatDialog from './components/creatDialog';
  import API from '../../../api/wareHouse/mcInbound.js';
  import DataBaseAPI from '@/api/dataBase';
  // import MASTER_API from '@/api/masterData/company.js';
  // import AGENCY_API from '@/api/agencyContract/index';
  import tableMixins from '@/common/mixins/table.js';
  // import { filterEmpty } from '@/common/js/util';
  // import siruiUpload from '@/components/SiruiUpload';
  import loading from '@/common/js/load.js'; //loading
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  import XEUtils from 'xe-utils';
  export default {
    name: 'mcInboundList',
    mixins: [tableMixins],
    components: {
      // siruiUpload,
      creatDialog,
      BatchConfirmDialog,
    },
    data() {
      return {
        // action: API.IMPORT,
        query: {
          inboundNo: null, //委托加工入库单号
          contractNo: null, //委托加工采购合同号
          externalContractNo: null, //委托加工外部合同号
          distributionInboundNo: null, //物流入库单号
          instructionNo: null, //供应商发货指令号
          inboundBatchNo: null, //入库批次号
          inboundStatus: null, //入库单状态
          productDesc: null, //商品描述
          productNo: null, //商品编码
          startInboundCreateDate: null, //制单日期开始
          endInboundCreateDate: null, //制单日期结束
          inboundCreatePersonNo: null, //制单人
          inboundCreatePersonName: null, //制单人姓名
          accountingStatus: null, //入账状态
          partnerNo: null, //供应商
          businessPersonNo: null, //业务员
          inboundCompanyCode: null, //公司
          inboundDepartmentCode: null, //部门
          inboundStorageNo: null, //商品入库仓库
          voucherNo: null,
        },
        companyList: [], //公司列表
        departmentList: [], //部门列表
        dialogVisible: false,
        postDate: '',
        isFinance: false, // 业务人员判断
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            //委托加工入库单号
            prop: 'inboundNo',
            name: this.$t('mcInboundList.search.inboundNo'),
            type: 'input',
            placeholder: this.$t('mcInboundList.search.inboundNoPlaceholder'),
          },
          {
            //委托加工采购合同号
            prop: 'contractNo',
            name: this.$t('mcInboundList.search.contractNo'),
            type: 'input',
            placeholder: this.$t('mcInboundList.search.contractNoPlaceholder'),
          },
          {
            //委托加工外部合同号
            prop: 'externalContractNo',
            name: this.$t('mcInboundList.search.externalContractNo'),
            type: 'input',
            placeholder: this.$t('mcInboundList.search.externalContractNoPlaceholder'),
          },
          // { //物流入库单号
          //   prop: "distributionInboundNo",
          //   name: this.$t("mcInboundList.search.distributionInboundNo"),
          //   type: "input",
          //   placeholder: this.$t("mcInboundList.search.distributionInboundNoPlaceholder"),
          // },
          // { //供应商发货指令号
          //   prop: "instructionNo",
          //   name: this.$t("mcInboundList.search.instructionNo"),
          //   type: "input",
          //   placeholder: this.$t("mcInboundList.search.instructionNoPlaceholder"),
          // },
          {
            //入库批次号
            prop: 'inboundBatchNo',
            name: this.$t('mcInboundList.search.inboundBatchNo'),
            type: 'input',
            placeholder: this.$t('mcInboundList.search.inboundBatchNoPlaceholder'),
          },
          {
            //入库单状态
            type: 'dict',
            prop: 'inboundStatus',
            name: this.$t('mcInboundList.search.inboundStatus'),
            // apiUrl: AGENCY_API.DICT_LIST,
            dictType: 'mc_inbound_status',
            placeholder: this.$t('mcInboundList.search.inboundStatusPlaceholder'),
            clearable: true,
          },
          {
            //商品描述
            prop: 'productDesc',
            name: this.$t('mcInboundList.search.productDesc'),
            type: 'input',
            placeholder: this.$t('mcInboundList.search.productDescPlaceholder'),
          },
          {
            //商品编码
            prop: 'productNo',
            name: this.$t('mcInboundList.search.productNo'),
            type: 'input',
            placeholder: this.$t('mcInboundList.search.productNoPlaceholder'),
          },
          {
            //制单日期开始
            prop: 'startInboundCreateDate',
            name: this.$t('mcInboundList.search.startInboundCreateDate'),
            placeholder: this.$t('mcInboundList.search.inboundCreateDatePlaceholder'),
            type: 'startDaterangePicker',
          },
          {
            //制单日期结束
            prop: 'endInboundCreateDate',
            name: this.$t('mcInboundList.search.endInboundCreateDate'),
            placeholder: this.$t('mcInboundList.search.inboundCreateDatePlaceholder'),
            type: 'endDaterangePicker',
          },
          {
            //制单人
            prop: 'inboundCreatePersonNo',
            name: this.$t('mcInboundList.search.inboundCreatePersonNo'),
            type: 'searchTableSpec',
            isMultiple: true,
            searchType: 'personnel',
            placeholder: this.$t('mcInboundList.search.inboundCreatePersonNoPlaceholder'),
          },
          {
            //入账状态
            type: 'dict',
            prop: 'accountingStatus',
            name: this.$t('mcInboundList.search.accountingStatus'),
            dictType: 'post_status',
            clearable: true,
          },
          {
            // 供应商
            type: 'searchTableSpec',
            prop: 'partnerNo',
            isMultiple: true,
            name: this.$t('mcInboundList.search.partnerNo'),
            searchType: 'supplier',
            extraData: {
              departmentCode: this.query.inboundDepartmentCode,
              companyCode: this.query.inboundCompanyCode,
            },
            // currentValue: this.baseData.partnerNo,
            // span: 12,
          },
          {
            //业务员
            type: 'searchTableSpec',
            prop: 'businessPersonNo',
            name: this.$t('mcInboundList.search.businessPersonNo'),
            isMultiple: true,
            searchType: 'personnel',
          },
          {
            //公司
            type: 'select',
            name: this.$t('mcInboundList.search.inboundCompanyCode'),
            prop: 'inboundCompanyCode',
            placeholder: this.$t('mcInboundList.search.inboundCompanyCodePlaceholder'),
            options: this.companyList,
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
          },
          {
            //部门
            type: 'select',
            prop: 'inboundDepartmentCode',
            name: this.$t('mcInboundList.search.inboundDepartmentCode'),
            placeholder: this.$t('mcInboundList.search.inboundDepartmentCodePlaceholder'),
            options: this.departmentList,
          },
          {
            //商品入库仓库
            type: 'searchTableSpec',
            name: this.$t('mcInboundList.search.inboundStorageNo'),
            prop: 'inboundStorageNo',
            placeholder: this.$t('mcInboundList.search.inboundStorageNoPlaceholder'),
            searchType: 'warehouse',
            isMultiple: true,
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
        ];
      },

      //表格显示字段
      columnListDefault() {
        return [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          { field: 'inboundNo', title: 'mcInboundList.table.inboundNo', visible: true, width: 120 }, //委托加工入库单号
          {
            field: 'contractNo',
            title: 'mcInboundList.table.contractNo',
            visible: true,
            width: 120,
          }, //委托加工采购合同号
          {
            field: 'externalContractNo',
            title: 'mcInboundList.table.externalContractNo',
            visible: true,
            width: 120,
          }, //委托加工外部合同号
          // { field: "distributionInboundNo",title: "mcInboundList.table.distributionInboundNo", visible: true,width: 120 },//物流入库单号
          // { field: "instructionNo",title: "mcInboundList.table.instructionNo", visible: true,width: 120 },//供应商发货指令号
          {
            field: 'inboundBatchNo',
            title: 'mcInboundList.table.inboundBatchNo',
            visible: true,
            width: 120,
          }, //入库批次号
          {
            field: 'productDesc',
            title: 'mcInboundList.table.productDesc',
            visible: true,
            width: 120,
          }, //商品描述
          { field: 'productNo', title: 'mcInboundList.table.productNo', visible: true, width: 120 }, //商品编码
          {
            field: 'inboundQuantity',
            title: 'mcInboundList.table.inboundQuantity',
            visible: true,
            width: 120,
          }, //商品数量
          {
            field: 'productUnit',
            title: 'mcInboundList.table.productUnit',
            dictType: 'basic_unit',
            visible: true,
            width: 120,
          }, //计量单位
          {
            field: 'matchedQuantity',
            title: 'businessReceiptList.table.matchedQuantity',
            visible: true,
            format: 'formatQuality',
          }, //已匹配数量
          {
            field: 'matchAvailableQuantity',
            title: 'businessReceiptList.table.matchAvailableQuantity',
            visible: true,
            format: 'formatQuality',
          }, //可匹配数量
          {
            field: 'partnerName',
            title: 'mcInboundList.table.partnerNo',
            visible: true,
            width: 120,
          }, //供应商
          {
            field: 'inboundStatus',
            title: 'mcInboundList.table.inboundStatus',
            type: 'dict',
            dictType: 'mc_inbound_status',
            visible: true,
            width: 120,
          }, //入库单状态
          {
            field: 'inboundStorageName',
            title: 'mcInboundList.table.inboundStorageNo',
            visible: true,
            width: 120,
          }, //商品入库仓库
          {
            field: 'accountingStatus',
            title: 'mcInboundList.table.accountingStatus',
            type: 'dict',
            dictType: 'post_status',
            visible: true,
            width: 120,
          }, //入账状态
          {
            field: 'voucherNo',
            title: '凭证号',
            visible: true,
          },
          {
            field: 'mcAmountWithTax',
            title: 'mcInboundList.table.mcAmountWithTax',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          }, //含税加工费
          {
            field: 'materialAmount',
            title: 'mcInboundList.table.materialAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          }, //原材料总金额
          {
            field: 'inboundCompanyName',
            title: 'mcInboundList.table.inboundCompanyCode',
            visible: true,
            width: 120,
          }, //公司
          {
            field: 'inboundDepartmentName',
            title: 'mcInboundList.table.inboundDepartmentCode',
            visible: true,
            width: 120,
          }, //部门
          {
            field: 'inboundCreatePersonName',
            title: 'mcInboundList.table.inboundCreatePersonNo',
            visible: true,
            width: 120,
          }, //制单人
          {
            field: 'businessPersonName',
            title: 'mcInboundList.table.businessPersonNo',
            visible: true,
            width: 120,
          }, //业务员
          // { field: "payableInvoiceStatus", title: "mcInboundList.table.payableInvoiceStatus", visible: true, width: 120,dictType:'payable-invoice-status'},
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      // //制单人默认
      // this.query.inboundCreatePersonNo = this.userInfo.userCode;
      // this.query.inboundCreatePersonName = this.userInfo.userName;
      // console.log(this.query.inboundCreatePersonNo);
      // console.log(this.query.inboundCreatePersonName);
      this.getData();
      // this.initDepartment();
      this.getCompany();
      this.getButtonList();
      this.$nextTick(() => {
        this.isFinance = !this.menuButtonList.find((item) => item.type === 'add');
      });
    },
    methods: {
      //获取数据
      getData() {
        const query = this.setSearchParams();
        this.load = true;
        this.$axios.post(API.GET_DATA_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // 查询参数整理
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        const query = { ...this.query, pageSize, pageNum };
        if (query.partnerNo && query.partnerNo.length > 0) {
          const { partnerCode } = query.partnerNo[0];
          query.partnerNo = partnerCode;
        }
        if (query.businessPersonNo && query.businessPersonNo.length > 0) {
          const { id } = query.businessPersonNo[0];
          query.businessPersonNo = id;
        }
        if (query.inboundStorageNo && query.inboundStorageNo.length > 0) {
          const { storageCode } = query.inboundStorageNo[0];
          query.inboundStorageNo = storageCode;
        }
        if (query.inboundCreatePersonNo && query.inboundCreatePersonNo.length > 0) {
          const { id } = query.inboundCreatePersonNo[0];
          query.inboundCreatePersonNo = id;
        }
        return query;
      },
      // 字符串转成驼峰
      transformStr3(str) {
        var re = /-(\w)/g;
        return str.replace(re, function ($0, $1) {
          return $1.toUpperCase();
        });
      },
      //调用接口排序
      sortChangeEvent({ property }) {
        this.query.sortfield = this.transformStr3(property);
        this.getData();
      },
      // 选择公司
      searchCompanyName(val) {
        console.log(val);
        this.departmentList = [];
        this.query.inboundDepartmentCode = '';
        this.getdepartmentList(val.val);
      },
      // 根据公司查询部门
      // 获取部门
      getdepartmentList(companyCode) {
        this.$axios.post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type === 'add') {
          this.add();
        } else if (type === 'export') {
          this.export();
        } else if (type === 'delete') {
          this.handleDelete();
        } else if (type == 'submit') {
          this.submit();
        } else if (type == 'syncVoucher') {
          //批量过账
          this.batchSyncVoucher(
            API.BATCH_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'signSyncVoucher') {
          //批量标记过账
          this.batchSyncVoucher(
            API.BATCH_SIGN_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'doBatchConfirm') {
          //批量生成凭证
          this.doBatchConfirm(
            'AE_PO_MC_INBOUND',
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
      },
      //批量提交
      submit() {
        if (this.multipleSelection.length !== 1) {
          this.$message({
            showClose: true,
            message: '请选择一条数据提交',
            type: 'error',
          });
          return;
        }
        loading.startLoading();
        this.$axios
          .post(
            API.BATCH_SUBMIT,
            this.multipleSelection.map((it) => it.id)
          )
          .then((res) => {
            loading.endLoading();
            if (0 == res.data.code) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.getData();
            } else {
              this.$alert(res.data.msg);
            }
          })
          .catch(() => loading.endLoading());
      },
      // 删除
      handleDelete() {
        this.$confirmAction()
          .then(() => {
            this.$axios
              .post(
                API.DELETE_INVOICE,
                this.multipleSelection.map((it) => it.id)
              )
              .then((res) => {
                if (0 == res.data.code) {
                  this.getData();
                  this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({ type: 'info', message: this.$t('confirm.deleteCancelled') });
          });
      },
      //新增
      add() {
        this.$refs.creatDialog.defaultVisible = true;
      },
      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      // 导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.POST_LIST_EXPORT}?${str}access_token=${this.userInfo.access_token}`;
        } else {
          let params = this.setSearchParams();
          params = XEUtils.serialize(params);
          window.location.href = `${this.baseUrl}${API.POST_LIST_EXPORT}?${params}&access_token=${this.userInfo.access_token}`;
        }
      },

      // 跳转详情页
      dblclickEvent(e) {
        let path = {
          path: '/wareHouse/mcInboundEdit',
          name: 'mcInboundEdit',
          meta: {
            keepAlive: true,
            title: '委托加工入库单详情',
          },
          query: {
            id: e.row.id,
            isEdit: 'N',
          },
        };
        console.log(e.row.id);
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 批量生成凭证
      selectDate() {
        const fundPayableInvoiceCredentialDTO = this.multipleSelection.map((i) => {
          return {
            id: i.id,
            version: i.version,
            postDate: this.postDate,
          };
        });
        this.$axios.post(API.GENERATE_CREDENTIALS, fundPayableInvoiceCredentialDTO).then((res) => {
          if (0 == res.data.code) {
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>
